<template>
  <div class="component-upload-image">
    <el-upload
      multiple
      :action="uploadUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      ref="imageUpload"
      :on-remove="handleDelete"
      :show-file-list="true"
      :headers="importHeaders"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{ hide: this.fileList.length >= this.limit }"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      请上传
      <template v-if="fileSize">
        大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
      </template>
      <template v-if="fileType">
        格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
      </template>
      的文件
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      title="预览"
      width="800"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
  </div>
</template>

<script>
import globaldata from "@/utils/globaldata";
import { getToken } from "@/utils/auth";
import messageUtils from "../../../utils/messageUtils";
import commonUtils from "@/utils/commonUtils";

export default {
  props: {
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      uploadUrl:
        process.env.BASE_API +
        `/upload/common/watermark/${
          globaldata.getAdminStore().storeFrontId
        }/uploadImage`,
      importHeaders: "",
      fileList: [],
    };
  },
  created() {
    console.log(this.value, "this.valueImage");
    let mytoken = getToken();
    this.importHeaders = { Authorization: mytoken };
  },
  watch: {
    value: {
      async handler(val) {
        if (val && val.length) {
          let list = [];
          for (let i = 0; i < this.value.length; i++) {
            list.push({ url: this.value[i] });
          }
          this.fileList = list;
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        messageUtils.errorMsg(
          this,
          `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
        );
        return false;
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          messageUtils.errorMsg(
            this,
            `上传头像图片大小不能超过 ${this.fileSize} MB!`
          );
          //   this.$modal.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
    //   this.$modal.loading("正在上传图片，请稍候...");
      this.number++;
    },
    // 文件个数超出
    handleExceed() {
      this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
      messageUtils.errorMsg(
            this,
            `上传文件数量不能超过 ${this.limit} 个!`
          );
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res, "上传成功回调");
      if (res.code != 20000) {
        messageUtils.errorMsg(this, res.message);
        return;
      }
      messageUtils.successMsg(this, "上传成功");
      this.fileList.push({
        url: res.data,
        name: file.name,
      });
      this.emitInput();
    },
    emitInput() {
      let value = [];
      for (let i = 0; i < this.fileList.length; i++) {
        value.push(this.fileList[i].url);
      }
      this.$emit("input", value);
    },
    // 删除图片
    handleDelete(file) {
      console.log(file, "文件");
      const findex = this.fileList.map((f) => f.url).indexOf(file.url);
      if (findex > -1) {
        this.fileList.splice(findex, 1);
        // this.$emit("input", this.fileList);
        this.emitInput();
      }
    },
    // 上传失败
    handleUploadError(res) {
    //   this.$modal.msgError("上传图片失败，请重试");
    //   this.$modal.closeLoading();
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        if (list[i].url) {
          strs += list[i].url + separator;
        }
      }
      // for (let i in list) {
      //   if (list[i].ossId) {
      //     strs += list[i].ossId + separator;
      //   }
      // }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },
  },
};
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}
// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

::v-deep .el-list-enter,
.el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/views/service/components/upload-image.vue